import { render, staticRenderFns } from "./DashboardPdfs.vue?vue&type=template&id=0ad076c1&scoped=true&"
import script from "./DashboardPdfs.vue?vue&type=script&lang=js&"
export * from "./DashboardPdfs.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPdfs.vue?vue&type=style&index=0&id=0ad076c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad076c1",
  null
  
)

export default component.exports